import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["childRadio", "confirmButton", "submit"];

  connect() {
    this.check();
  }

  // Called on change events for child radios and hidden inputs
  check() {
    const childChosen = this.childRadioTargets.some((el) => el.checked);

    const ready = childChosen;

    this.submitTarget.disabled = !ready;

    if (this.hasConfirmButtonTarget) {
      this.confirmButtonTarget.disabled = !ready;
    }
  }
}
